/** Session-scoped password for save/delete template mutations. */

const STORAGE_KEY = 'design-studio:template-password';

export function getSessionTemplatePassword(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

export function setSessionTemplatePassword(password: string): void {
  try {
    if (password) sessionStorage.setItem(STORAGE_KEY, password);
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* private mode */
  }
}

export function clearSessionTemplatePassword(): void {
  setSessionTemplatePassword('');
}
